import ApiService from '@apis/api-service'
import { API_PATHS } from '@constants/paths'

const fetchCurrentUser = () =>
  ApiService.get(API_PATHS.users.current).then((response) => response.data.user)

const update = (id, params) => {
  const { email, firstName, lastName, marketingEmailEnabled, npn, residentState, licenseNumber } =
    params

  return ApiService.put(API_PATHS.users.update(id), {
    email,
    firstName,
    lastName,
    marketingEmailEnabled,
    npn,
    residentState,
    licenseNumber,
  }).then((response) => response.data.user)
}

const UserApiService = {
  fetchCurrentUser,
  update,
}

export default UserApiService
